import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';
import { useMutation } from 'react-query';
import { getQuestReportCustomerWithoutMovement } from './CustomerWithoutMovement.service';

export function useCustomerWithoutMovementReport() {
  return useMutation(getQuestReportCustomerWithoutMovement, {
    onSuccess() {
      notification.success({
        message: 'Relatório cliente sem movimentação gerado com sucesso!',
      });
    },

    onError(error) {
      notificationError(error);
    },
  });
}
